import { pageBannerEndId } from 'Core/variables';

let $pagination = $('.pagination');

const addHash = function () {
	let $links = $pagination.find('a');

	$links.each(function (index, el) {
		el.href += '#' + pageBannerEndId;
	});
};

export const PaginationWatcher = function () {
	$(document).ready(function () {
		if ($pagination.length > 0) {
			addHash();
		}
	});
};
